import api, { API_UPLOAD_TIMEOUT_MS } from "./api";

export const fetchWallet = () => api.get("/payments/wallet/");
export const fetchWithdrawalQuote = (params = {}) =>
  api.get("/payments/wallet/withdrawal-quote/", { params });
export const fetchMyDeposits = () => api.get("/payments/wallet/deposits/");
export const fetchMyWithdrawals = () => api.get("/payments/wallet/withdrawals/");
export const getMyWithdrawalProofSignedUrl = (withdrawalId) =>
  api.get(`/payments/wallet/withdrawals/${withdrawalId}/proof-signed/`);
export const fetchMyTransactions = (params = {}) => api.get("/payments/wallet/transactions/", { params });
export const downloadMyTransactionsCsv = async (params = {}) => {
  const res = await api.get("/payments/wallet/transactions/export/csv/", { params, responseType: "blob" });
  const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "my_transactions.csv";
  a.click();
  window.URL.revokeObjectURL(url);
};
export const downloadMyTransactionsPdf = async (params = {}) => {
  const res = await api.get("/payments/wallet/transactions/export/pdf/", { params, responseType: "blob" });
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "my_transactions.pdf";
  a.click();
  window.URL.revokeObjectURL(url);
};
export const submitDepositRequest = (payload, proofFile = null) => {
  if (proofFile) {
    const form = new FormData();
    Object.entries(payload || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      form.append(key, String(value));
    });
    form.append("proof", proofFile);
    return api.post("/payments/wallet/deposit/", form, { timeout: API_UPLOAD_TIMEOUT_MS });
  }
  return api.post("/payments/wallet/deposit/", payload);
};
export const submitWithdrawalRequest = (payload) => api.post("/payments/wallet/withdraw/", payload);

export const listAdminDeposits = () => api.get("/payments/admin/deposits/");
export const reviewAdminDeposit = (id, payload) => api.patch(`/payments/admin/deposits/${id}/review/`, payload);
export const bulkReviewAdminDeposits = (payload) => api.post("/payments/admin/deposits/bulk-review/", payload);
export const presignDepositUpload = (payload) => api.post("/payments/wallet/deposit-upload/presign/", payload);
export const getMyDepositScreenshotSignedUrl = (depositId) =>
  api.get(`/payments/wallet/deposits/${depositId}/screenshot-signed/`);
export const getAdminDepositScreenshotSignedUrl = (depositId) =>
  api.get(`/payments/admin/deposits/${depositId}/screenshot-signed/`);
export const fetchSuperAdminDepositOverview = () => api.get("/payments/admin/deposits/super-overview/");

export const listAdminWithdrawals = () => api.get("/payments/admin/withdrawals/");
export const reviewAdminWithdrawal = (id, payload) =>
  api.patch(`/payments/admin/withdrawals/${id}/review/`, payload);
export const presignAdminWithdrawalProofUpload = (payload) =>
  api.post("/payments/admin/wallet/withdrawals/upload-proof/presign/", payload);
export const getAdminWithdrawalProofSignedUrl = (id) =>
  api.get(`/payments/admin/wallet/withdrawals/${id}/proof-signed/`);
export const listAdminTransactions = (params = {}) => api.get("/payments/admin/transactions/", { params });
